import Swiper from "swiper";

class SwiperCarousel {
    constructor(element, additionalParams) {
        this.element = element;
        this.additionalParams = additionalParams;
    }

    /**
     * Initiates Swiper plugin object
     */
    init() {
        // Convert jQuery object to DOM element if needed
        const element = this.element.jquery ? this.element[0] : this.element;
        this.swiper = new Swiper(element, this.getParameters());
        return this.swiper;
    }

    /**
     * Returns instance of the Swiper attached
     * to instance
     * @returns {Swiper}
     */
    getInstance() {
        return this.swiper;
    }

    getParameters() {
        let swiperParams = {
            slidesPerView: 'auto',
            loop: false,
        };

        return this.swiperParams = Object.assign(swiperParams, this.additionalParams);
    }
}

export default SwiperCarousel;



// WEBPACK FOOTER //
// ./scripts/components/swiper-carousel.js